/* ============================================================
   Eagle Bourbon – Eagle Picks Swiper  |  assets/eagle-picks.js
   ============================================================ */

(function () {
  'use strict';

  /* Wait for Swiper to be available (it loads via CDN with defer) */
  function waitForSwiper(cb, attempts) {
    attempts = attempts || 0;
    if (typeof Swiper !== 'undefined') {
      cb();
    } else if (attempts < 40) {
      setTimeout(function () { waitForSwiper(cb, attempts + 1); }, 100);
    }
  }

  /* ──────────────────────────────────────────
     Init one Eagle Picks section
  ────────────────────────────────────────── */
  function initSection(section) {
    var sectionId  = section.dataset.sectionId;
    var swiperEl   = document.getElementById('ep-swiper-' + sectionId);
    var prevEl     = document.getElementById('ep-prev-'   + sectionId);
    var nextEl     = document.getElementById('ep-next-'   + sectionId);

    if (!swiperEl) return;

    var swiper = new Swiper(swiperEl, {
      /* ── Core ── */
      slidesPerView: 'auto',   /* fallback — breakpoints override */
      spaceBetween: 12,
      grabCursor: true,
      watchSlidesProgress: true,

      /* ── Touch / momentum ── */
      freeMode: {
        enabled: false,        /* snap scrolling — feels intentional */
      },
      resistance: true,
      resistanceRatio: 0.65,

      /* ── Snap ── */
      speed: 420,
      cssMode: false,          /* JS-driven for momentum + arrow support */

      /* ── Accessibility ── */
      a11y: {
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product'
      },
      keyboard: { enabled: true, onlyInViewport: true },

      /* ── Arrows ── */
      navigation: prevEl && nextEl ? {
        prevEl: prevEl,
        nextEl: nextEl,
        disabledClass: 'swiper-button-disabled'
      } : false,

      /* ─────────────────────────────────────
         Breakpoints
         Mobile  (<600px) : exactly 2 cards visible, ~16px gap
         Tablet  (600px+) : 3 cards
         Desktop (960px+) : 4 cards
         Large   (1280px+): 4.5 cards (hint of 5th)
      ──────────────────────────────────────*/
      breakpoints: {
        0: {
          slidesPerView: 2,      /* ← 2 full cards on all mobile sizes */
          spaceBetween: 10,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        600: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        960: {
          slidesPerView: 4,
          spaceBetween: 15
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });

    /* Update arrow disabled state after resize */
    window.addEventListener('resize', function () {
      swiper.update();
    }, { passive: true });
  }

  /* ──────────────────────────────────────────
     AJAX Add to Cart
  ────────────────────────────────────────── */
  function initATC(section) {
    var cartUrl = section.dataset.cartAddUrl || '/cart/add';

    section.addEventListener('submit', function (e) {
      var form = e.target.closest('.ep-card__form');
      if (!form) return;
      e.preventDefault();

      var btn       = form.querySelector('.ep-card__atc');
      var variantId = form.querySelector('[name="id"]').value;
      var qty       = form.querySelector('[name="quantity"]').value || 1;

      if (!variantId || btn.disabled) return;

      var originalText = btn.textContent.trim();
      btn.textContent = '...';
      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch(cartUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart error');
          return res.json();
        })
        .then(function () {

  btn.classList.remove('is-loading');
  btn.classList.add('is-added');
  btn.textContent = '✓ Added!';

// Let the theme update the mini cart itself
  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      button: btn,
      variant: null,
      quantity: Number(qty),
      productAdded: true
    }
  }));

  setTimeout(function () {
    btn.textContent = originalText;
    btn.classList.remove('is-added');
    btn.disabled = false;
  }, 2400);

})
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.textContent = 'Try Again';
          btn.disabled = false;
        });
    });
  }

  /* ── Update cart count badges ── */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var selectors = [
          '[data-cart-count]',
          '.cart-count',
          '.cart-item-count',
          '.header__cart-count',
          '.cart-count-bubble span[aria-hidden]'
        ];
        document.querySelectorAll(selectors.join(', ')).forEach(function (el) {
          el.textContent = count;
        });
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.style.display = count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ──────────────────────────────────────────
     Boot all sections on page
  ────────────────────────────────────────── */
  function bootAll() {
    waitForSwiper(function () {
      document.querySelectorAll('.ep-section').forEach(function (section) {
        initSection(section);
        initATC(section);
      });
    });
  }

  /* DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* Theme editor: re-init on section load */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ep-section');
    if (!section) return;
    waitForSwiper(function () {
      initSection(section);
      initATC(section);
    });
  });

})();




/**
 * Eagle Bourbon — Newsletter Section JS
 * File: assets/eagle-newsletter.js
 *
 * Handles:
 *  - Layout class (split vs centered) from schema setting
 *  - Form submission loading state
 *  - Inline validation feedback
 *  - Theme Editor live reload
 */

(function () {
  'use strict';

  function initNewsletter(section) {
    if (!section) return;

    const sectionEl = section.querySelector('.eagle-nl');
    if (!sectionEl) return;

    /* ── Apply layout class ─────────────────────────────────── */
    // Read layout from a data attr we inject via liquid (see below)
    const layout = sectionEl.dataset.layout || 'split';
    if (layout === 'centered') {
      sectionEl.classList.add('eagle-nl--centered');
    } else {
      sectionEl.classList.remove('eagle-nl--centered');
    }

    /* ── Form UX ─────────────────────────────────────────────── */
    const form = sectionEl.querySelector('.eagle-nl__form');
    const btn  = sectionEl.querySelector('.eagle-nl__btn');
    const emailInput = sectionEl.querySelector('.eagle-nl__input--email');

    if (!form || !btn || !emailInput) return;

    // Remove any existing listener clone trick
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    const liveBtn   = sectionEl.querySelector('.eagle-nl__btn');
    const liveEmail = sectionEl.querySelector('.eagle-nl__input--email');

    newForm.addEventListener('submit', function (e) {
      // Basic email validation
      const email = liveEmail.value.trim();
      if (!email || !isValidEmail(email)) {
        e.preventDefault();
        showError(liveEmail, 'Please enter a valid email address.');
        return;
      }

      // Loading state
      liveBtn.classList.add('eagle-nl__btn--loading');
      const btnText = liveBtn.querySelector('.eagle-nl__btn-text');
      if (btnText) btnText.textContent = 'Subscribing';
    });

    // Clear error on input
    liveEmail.addEventListener('input', function () {
      clearError(liveEmail);
    });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(input, message) {
    clearError(input);
    input.style.borderColor = '#A83A2A';
    input.setAttribute('aria-invalid', 'true');

    const err = document.createElement('p');
    err.className = 'eagle-nl__error';
    err.setAttribute('role', 'alert');
    err.textContent = message;
    err.style.cssText = 'font-family:Lora,Georgia,serif;font-size:12px;color:#C05040;margin:4px 0 0;';
    input.closest('.eagle-nl__email-row').insertAdjacentElement('afterend', err);

    input.focus();
  }

  function clearError(input) {
    input.style.borderColor = '';
    input.removeAttribute('aria-invalid');
    const row = input.closest('.eagle-nl__email-row');
    if (!row) return;
    const err = row.nextElementSibling;
    if (err && err.classList.contains('eagle-nl__error')) {
      err.remove();
    }
  }

  /* ── Boot ─────────────────────────────────────────────────── */
  function boot() {
    document.querySelectorAll('.eagle-newsletter-section').forEach(function (sec) {
      initNewsletter(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── Shopify Theme Editor support ────────────────────────── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initNewsletter(e.target);
    });
  }

})();



/**
 * Eagle Bourbon — Popular Categories
 * File: assets/eagle-popular-categories.js
 *
 * Handles:
 *  - Carousel mode: Swiper init with responsive breakpoints
 *  - Grid mode: no Swiper needed, pure CSS grid
 *  - Reads layout mode from data-layout attribute on section
 *  - Shopify Theme Editor live reload support
 */

(function () {
  'use strict';

  var swiperInstances = [];

  /* ── Destroy any existing swiper instances for a section ── */
  function destroySwiper(section) {
    swiperInstances = swiperInstances.filter(function (entry) {
      if (entry.sectionEl === section) {
        try { entry.swiper.destroy(true, true); } catch (e) {}
        return false;
      }
      return true;
    });
  }

  /* ── Init Swiper for a single carousel section ── */
  function initCarousel(section) {
    var swiperEl = section.querySelector('.eagle-categories__swiper');
    if (!swiperEl) return;

    var prevBtn      = swiperEl.querySelector('.eagle-categories__btn--prev');
    var nextBtn      = swiperEl.querySelector('.eagle-categories__btn--next');
    var paginationEl = swiperEl.querySelector('.eagle-categories__pagination');
    var totalSlides  = swiperEl.querySelectorAll('.eagle-categories__slide').length;
    var sectionId    = section.id || '';

    var swiper = new Swiper(swiperEl, {

      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 12,

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous category',
        nextSlideMessage: 'Next category',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      grabCursor: true,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      threshold: 5,

      loop: totalSlides > 4,
      loopAdditionalSlides: 2,
      speed: 420,

      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
      },

      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 14,
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        900: {
          slidesPerView: 5,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        1100: {
          slidesPerView: totalSlides <= 6 ? totalSlides : 6,
          slidesPerGroup: totalSlides <= 6 ? totalSlides : 6,
          spaceBetween: 18,
          loop: false,
          allowTouchMove: totalSlides > 6,
        },
      },

      on: {
        init: function (sw) {
          updateNavVisibility(sw);
        },
        breakpoint: function (sw) {
          updateNavVisibility(sw);
        },
        slideChange: function (sw) {
          var activeSlide = sw.slides[sw.activeIndex];
          if (!activeSlide) return;
          var label = activeSlide.querySelector('.eagle-categories__label');
          if (!label) return;
          var liveEl = document.getElementById('eagle-cats-sr-live-' + sectionId);
          if (!liveEl) {
            liveEl = document.createElement('span');
            liveEl.id = 'eagle-cats-sr-live-' + sectionId;
            liveEl.setAttribute('aria-live', 'polite');
            liveEl.setAttribute('aria-atomic', 'true');
            liveEl.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
            document.body.appendChild(liveEl);
          }
          liveEl.textContent = label.textContent.trim();
        },
      },
    });

    function updateNavVisibility(sw) {
      if (!prevBtn || !nextBtn) return;
      var showNav = sw.params.loop || (sw.slides.length > sw.params.slidesPerView);
      prevBtn.style.display = showNav ? '' : 'none';
      nextBtn.style.display = showNav ? '' : 'none';
    }

    swiperInstances.push({ sectionEl: section, swiper: swiper });
  }

  /* ── Init a single section based on its layout mode ── */
  function initSection(section) {
    destroySwiper(section);
    var layout = section.dataset.layout || 'carousel';
    if (layout === 'carousel') {
      if (typeof Swiper !== 'undefined') {
        initCarousel(section);
      } else {
        pollSwiper(section);
      }
    }
    /* Grid mode: nothing to do — CSS handles it */
  }

  /* ── Poll until Swiper loads ── */
  function pollSwiper(section) {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        clearInterval(poll);
        initCarousel(section);
      }
      if (attempts > 40) clearInterval(poll);
    }, 100);
  }

  /* ── Init all sections on the page ── */
  function initAll() {
    document.querySelectorAll('.eagle-categories[data-layout]').forEach(initSection);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Shopify Theme Editor support ── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.eagle-categories');
      if (section) initSection(section);
    });
    document.addEventListener('shopify:block:select', initAll);
    document.addEventListener('shopify:block:deselect', initAll);
  }

})();



document.addEventListener("DOMContentLoaded", function(){

document.querySelectorAll('.gift-addon').forEach(function(box){

box.addEventListener('change', function(){

let variantId = this.dataset.variant;

if(this.checked){

fetch('/cart/add.js',{
method:'POST',
headers:{
'Content-Type':'application/json'
},
body:JSON.stringify({
id:variantId,
quantity:1
})
});

}else{

fetch('/cart.js')
.then(res=>res.json())
.then(cart=>{

cart.items.forEach(item=>{

if(item.variant_id == variantId){

fetch('/cart/change.js',{
method:'POST',
headers:{
'Content-Type':'application/json'
},
body:JSON.stringify({
id:item.key,
quantity:0
})
});

}

});

});

}

});

});

});